import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import stringHelper from 'utils/stringHelper';

import Stack from '@mui/material/Stack';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

import MenuItem from '@mui/material/MenuItem';



import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';

import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';


import CircularProgress from '@mui/material/CircularProgress';

import { green } from '@mui/material/colors';


import { ReclamationActionDetailCodes } from 'constants.js';
import { ReclamationActionDetailType } from 'constants.js';
import { TypeActionCodes } from 'constants.js';


const styles = theme => ({
    cardActions: {
        justifyContent: 'right'
    },


    formControl: {
        margin: 0,
        width: '100%'
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    }

});



const consignes = [
    "Renvoi de la marchandise refusée",
    "Avoir à établir sur les marchandises manquantes",
    "Autres"
];


function uniqueCodeArticle(value, index, self) {
    return self.slice(index + 1).findIndex((currentValue, i, r) => currentValue.codeArticle === value.codeArticle) === -1;
}

class QualificationCodeRefusDeLivraisonPartielForm extends React.Component {


    constructor(props) {
        super(props);

        // Initialisation du state
        this.state = this.getInitialState();
    }

    getInitialState = () => {
        const initialState = {
            open: false,
            date: '',
            consigne: '',
            commentaire: '',
            articles: null,
            autres: ''
        };
        return initialState;
    }


    UNSAFE_componentWillUpdate(nextProps, nextState) {

        const { isLoading } = this.props;
        
        if (isLoading && !nextProps.isLoading) {

            let articles = [];

            if (nextProps.infosLogistique && nextProps.infosLogistique.colis) {

                articles = nextProps.infosLogistique.colis.map(colis => {
                    return colis.lignes;
                }).flat(1).map(x => {
                    return { codeArticle: x.codeArticle, quantite: 0, designationArticle: x.designationArticle };
                    }).filter(uniqueCodeArticle)
                    .sort(function (a, b) { return a.codeArticle > b.codeArticle; });
            }

            this.setState(
            {
                ...this.state,
                articles: articles
            });            
        }
    }

       

    handleChange = (event) => {
        const newState = {
            ...this.state,
            [event.target.name]: event.target.value
        };


        if (newState.reponse !== this.state.reponse) {
            newState.typeErreur = -1;
            newState.motif = '';
            newState.numeroPiece = '';
        }

        this.setState(newState);
        
    }

    handleChangeQuantite = (event, l) => {
        const newState = {
            ...this.state
        };
        newState.articles[l].quantite = Math.max(event.target.value, 0);

        this.setState(newState);
    }

    handleClickAnswer = (event) => {
        const newState = {
            ...this.state,
            open: true
        };

        this.setState(newState);
    }

    handleClickCancel = (event) => {
        this.setState(this.getInitialState());
    }


    // Sauvergarde pour le cas messager
    handleClickSave = (event) => {

        const { addAction, groupeTransportId, reclamationId, actionId } = this.props;

        const { date, consigne, commentaire, articles, autres } = this.state;


        let sauvegardable = (consigne === 0 && date)
            || (consigne === 1)
            || (consigne === 2 && autres);

        if (!sauvegardable) {
            return;
        }



        // Action data
        const actionData = {
            code: TypeActionCodes.SouffranceTransporteurMemoReponse,
            parentReclamationActionId: actionId,
            details: [{
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: 'Consigne client',
                position: 0,
                valeurString: consignes[consigne] + ((consigne === 2) ? (' - ' + autres)  : ''),
                valeurInteger: consigne
            }]
        };


        if (consigne === 0) {

            let detail = {
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.Date,
                libelle: 'Date',
                position: actionData.details.length,
                valeurDate: date
            };

            actionData.details.push(detail);
        }
        

        // Articles
        if (articles) {
            for (let i = 0; i < articles.length; i++) {
                actionData.details.push({
                    code: ReclamationActionDetailCodes.CodeArticleQuantite,
                    type: ReclamationActionDetailType.CodeArticleQuantite,
                    libelle: 'Code article avec quantité refusée',
                    position: actionData.details.length,
                    valeurInteger: articles[i].quantite,
                    valeurString: articles[i].codeArticle
                });
            }
        }


        if (!stringHelper.isNullOrWhitespace(commentaire)) {

            let detail = {
                code: ReclamationActionDetailCodes.Commentaire,
                type: ReclamationActionDetailType.Texte,
                libelle: "Commentaire",
                position: actionData.details.length,
                valeurString: commentaire
            };

            actionData.details.push(detail);
        }
                
        addAction(reclamationId, actionData, actionId, groupeTransportId);

    }

    render() {
        const { classes, isAdding } = this.props;

        const { open, consigne, commentaire, articles, date, autres } = this.state;




        let sauvegardable =    (consigne === 0 && date)
                            || (consigne === 1)
                            || (consigne === 2 && autres);


        return (

            <React.Fragment>

                <div hidden={open || isAdding}>
                    <Button onClick={this.handleClickAnswer} variant="outlined" >Répondre</Button>
                </div>


                <Card hidden={!open && !isAdding}>

                    <CardContent sx={{ minWidth: '500px' }}>

                        <Stack spacing={1}>

                            <TextField
                                select
                                label="Consigne client"
                                value={consigne}
                                onChange={this.handleChange}
                                name="consigne"
                                className={classes.selectEmpty}
                            >
                                {consignes.map((r, index) => (
                                    <MenuItem key={index} value={index}>
                                        {r}
                                    </MenuItem>
                                ))}
                            </TextField>

                            {(consigne === 0) && (
                                <TextField
                                    id="date"
                                    name="date"
                                    label="Date de relivraison souhaitée"
                                    type="date"
                                    value={date}
                                    onChange={this.handleChange}
                                    InputLabelProps={{ shrink: true }}
                                    fullWidth
                                />
                            )}

                            {consigne === 2 && (

                                <TextField className={classes.formControl}
                                    id="autres"
                                    name="autres"
                                    label="Autres"
                                    placeholder="Merci de préciser"
                                    margin="normal"
                                    value={autres}
                                    onChange={this.handleChange}
                                />

                            )}

                            {articles && (

                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={classes.cell}>Code article</TableCell>
                                            <TableCell className={classes.cell}>Désignation</TableCell>
                                            <TableCell className={classes.cell}>Quantité refusée</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {articles.map((x, index) => (
                                            <TableRow key={index}>
                                                <TableCell className={classes.cell}>{x.codeArticle}</TableCell>
                                                <TableCell className={classes.cell}>{x.designationArticle}</TableCell>
                                                <TableCell className={classes.cell}><TextField type="number" value={x.quantite} onChange={e => this.handleChangeQuantite(e, index)} /></TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            )}

                            <TextField className={classes.formControl}
                                id="commentaire"
                                name="commentaire"
                                label="Commentaire"
                                placeholder="Commentaire"
                                multiline
                                margin="normal"
                                value={commentaire}
                                onChange={this.handleChange}
                            />

                        </Stack>

                    </CardContent >

                    <CardActions classes={{ root: classes.cardActions }}>
                        <Button onClick={this.handleClickCancel} color="primary" >Annuler</Button>
                        <Button
                            onClick={this.handleClickSave}
                            variant="contained"
                            color="secondary"
                            disabled={!sauvegardable || isAdding}
                        >
                            {isAdding === true && <CircularProgress size={24} className={classes.buttonProgress} />}
                            Enregistrer
                                </Button>
                    </CardActions>


                </Card>
            </React.Fragment>
        );
    }
}
QualificationCodeRefusDeLivraisonPartielForm.propTypes = {
    isAdding: PropTypes.bool.isRequired
};

export default withStyles(styles)(QualificationCodeRefusDeLivraisonPartielForm);